module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pagination) ? _c('div', [_c('span', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v("Página " + _vm._s(_vm.pagination.current_page) + " de " + _vm._s(_vm.pagination.last_page))]), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "page-count": _vm.pagination.last_page,
      "current-page": _vm.pagination.current_page
    },
    on: {
      "current-change": _vm.navigation,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pagination, "current_page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pagination, "current_page", $event)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticStyle: {
      "font-size": "9pt"
    }
  }, [_vm._v(_vm._s(_vm.pagination.total) + " registro(s)")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f6368d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/common/paginate.vue
// module id = 1467
// module chunks = 44